import { create } from 'zustand'

type SendAwardFormStore = {
  isFormDirty: boolean
  setIsFormDirty: (isDirty: boolean) => void
}

export const useSendAwardFormStore = create<SendAwardFormStore>(set => ({
  isFormDirty: false,
  setIsFormDirty: isDirty => set({ isFormDirty: isDirty }),
}))
